<template>
  <div class="harness-accordion-menu">
    <div class="search-box">
      <input
        type="text"
        placeholder="Search..."
        aria-label="Search the survey questions"
        v-model="searchString"
        @input="onSearchChange"
      >
      <button
        @click="clearSearch"
        aria-label="Clear the search term"
      >
        <i class="bi bi-x-circle" />
      </button>
    </div>
    <accordion-group
      v-for="module in accordionData"
      :key="module.key"
      :group="module"
      :is-selected="isGroupExpanded(module.key)"
      :selected-value="getFilter(filter.key)"
      :get-value-properties="getValueProperties"
      :use-sub-selection="$attrs['use-sub-selection']"
      :selected-question="selectedQuestion"
      :expanded-question="expandedQuestion"
      :selected-levels="$attrs['selected-levels']"
      :search-string="searchString"
      @onExpandGroup="expandGroup(module.key)"
      @onExpandQuestion="expandQuestion($event)"
      @onSelectQuestion="selectQuestion($event)"
    />
  </div>
</template>

<script>
import AccordionGroup from './AccordionGroup.vue'

export default {
  name: 'AccordionFilter',
  inheritAttrs: true,
  props: {
    filter: {
      type: Object,
      default: null
    },
    getValueProperties: {
      type: Function,
      default: null
    }
  },
  components: { AccordionGroup },
  data () {
    return {
      expandedGroup: [],
      expandedQuestion: null,
      searchString: null
    }
  },
  mounted () {
    if (this.selectedQuestion == null) {
      return
    }

    const preSelectGroup = Object.values(this.accordionData).find(g => {
      return g.members.find(gm => gm === this.selectedQuestion.id) != null
    })

    if (preSelectGroup) {
      this.expandedGroup = [preSelectGroup.key]
      this.expandedQuestion = this.selectedQuestion.id
    }
  },
  computed: {
    accordionData () {
      const data = this.getOptionsForFilter(this.filter.key) || {}

      if (this.searchString == null || this.searchString.length < 3) {
        return data.groups
      }

      const out = {}
      Object.keys(data.groups).forEach(k => {
        const g = data.groups[k]
        const filtered = g.members.filter(m => this.doesMatchSearch(m))

        if (filtered.length > 0) {
          out[k] = {
            ...g,
            members: filtered
          }
        }
      })

      return out
    },
    selectedQuestion () {
      return this.$attrs['selected-question']
    }
  },
  methods: {
    expandQuestion ({ id, expand }) {
      if (expand) {
        this.expandedQuestion = id
      } else {
        this.expandedQuestion = null
      }
    },
    expandGroup (key) {
      const index = this.expandedGroup.indexOf(key)

      if (index >= 0) {
        this.expandedGroup.splice(index, 1)
      } else {
        this.expandedGroup.push(key)
      }
    },
    selectQuestion ({ id, levels }) {
      this.setFilter(this.filter.key, id)

      const onSelect = this.$attrs['on-accordion-select']
      if (onSelect) {
        onSelect({ id, levels })
      }
    },
    doesMatchSearch (groupValue) {
      if (this.searchString == null) {
        return true
      }

      const properties = this.getValueProperties(groupValue)
      const regex = new RegExp(this.searchString, 'gi')
      return properties.label.match(regex) || groupValue.match(regex)
    },
    isGroupExpanded (id) {
      return this.expandedGroup.indexOf(id) > -1
    },
    onSearchChange () {
      if (this.searchString != null && this.searchString.length > 0) {
        this.expandedGroup = Object.keys(this.accordionData)
      } else {
        this.expandedGroup = []
      }
    },
    clearSearch () {
      this.searchString = null
      this.onSearchChange()
    }
  }
}
</script>

<style lang="scss" scoped>
.harness-accordion-menu {
  min-width: 300px;
}

.search-box {
  padding: 4px;
  padding-left: 8px;
  margin-bottom: 8px;

  display: flex;

  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #aaa;

  input {
    flex: 1 1 auto;

    width: 100%;
    padding: 4px;
    border: 0;
    background: none;
  }

  button {
    flex: 0 0 auto;
    border: 0;
    background: none;

    transition: 300ms ease all;

    &:hover {
      color: #267cb8;
      transform: scale(1.2);
    }
  }
}
</style>
